import { render } from "./product-entrance-and-exit.vue?vue&type=template&id=c7e237ae"
import script from "./product-entrance-and-exit.vue?vue&type=script&lang=js"
export * from "./product-entrance-and-exit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__